var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHiddenOutlineicon = function SvgHiddenOutlineicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.9.92a.38.38 0 0 0-.56 0l-.42.42a.38.38 0 0 0 0 .56L3 4A7.73 7.73 0 0 0 .05 7.74.8.8 0 0 0 0 8c0 .09.02.17.05.25a8.51 8.51 0 0 0 11.68 4.48l2.36 2.35a.38.38 0 0 0 .56 0l.42-.42a.38.38 0 0 0 0-.56L1.9.92ZM8 12a7.05 7.05 0 0 1-6.34-4 6.49 6.49 0 0 1 2.5-2.85l1.72 1.73a2.4 2.4 0 0 0 3.2 3.2l1.41 1.4c-.8.33-1.64.5-2.5.52ZM5.7 2.72a8.56 8.56 0 0 1 10.29 5.04V8c0 .09-.01.18-.05.26a7.29 7.29 0 0 1-1.86 2.85l-1.14-1.13A5.8 5.8 0 0 0 14.34 8a7.05 7.05 0 0 0-7.3-3.93L5.7 2.72Z",
    clipRule: "evenodd"
  })));
};
export default SvgHiddenOutlineicon;